import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';

import WANDERU_LOGO from './assets/wanderu-logo.svg';

import styles from './Logo.scss';

const propTypes = {
    className: PropTypes.string,
    isExternal: PropTypes.bool,
    link: PropTypes.bool,
    native: PropTypes.bool,
};

const HOME_URL = '/';
const SITE_URL = 'https://www.wanderu.com/';

function Chiku(props) {
    const { className } = props;

    return (
        <div className={classNames(styles.logo, className)}>
            <img
                alt="Wanderu Logo"
                className={styles.wanderuLogo}
                height="32"
                src={WANDERU_LOGO}
                width="138"
            />
        </div>
    );
}

Chiku.propTypes = {
    className: PropTypes.string,
};

function Logo(props) {
    const {
        className = '',
        isExternal = false,
        link = false,
        native = true,
    } = props;

    const url = isExternal
        ? SITE_URL
        : HOME_URL;

    if (link) {
        return (
            <A
                className={className}
                href={url}
                native={native}
                target={isExternal
                    ? '_blank'
                    : undefined}
                title="Wanderu"
            >
                <Chiku />
            </A>
        );
    }

    return (
        <Chiku className={className} />
    );
}

Logo.propTypes = propTypes;

export {
    Chiku,
    Logo,
};
export default Logo;
